import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CardMedia, CardContent, Typography, Box, Chip, Grid, Divider, IconButton } from '@mui/material';
import YouTubeIcon from '@mui/icons-material/YouTube';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import CloseIcon from '@mui/icons-material/Close';
import StarIcon from '@mui/icons-material/Star';

const RecommendationDetail = ({ open, onClose, recommendation }) => {

  const generateTrailerLink = (title, year) => {
    const query = `${title} ${year} trailer`;
    const encodedQuery = encodeURIComponent(query);
    return `https://www.youtube.com/results?search_query=${encodedQuery}`;
  };

  const renderVoterChip = (voter) => (
    <Chip
      key={voter.first_name + ' ' + voter.last_name}
      label={
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {voter.first_name + ' ' + voter.last_name}
          {voter.is_critic && <StarIcon sx={{ ml: 0.5, fontSize: 16 }} />}
        </Box>
      }
      size="small"
      color = {voter.is_critic? "secondary":"primary"}
      sx={{
        marginLeft: 1,
        marginBottom: 1,
      }}
    />
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <Typography variant="h5" align="center">
          {recommendation?.show.title}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            padding: '2px',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <CardMedia
              component="img"
              height="400"
              image={recommendation?.show.posterUrl}
              alt={recommendation?.show.title}
              style={{ objectFit: 'contain' }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CardContent>
              <Typography variant="body2" color="text.secondary" paragraph>
                <strong>TMDB Rating:</strong> {recommendation?.show.voteAverage}
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                <strong>Plataforma:</strong> {recommendation?.show.platforms}
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                <strong>Tipo:</strong> {recommendation?.show.type}
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                <strong>Géneros:</strong> {recommendation?.show.genres.split(',').map((genre, index) => (
                  <Typography key={index} variant="body2" component="span" color="text.secondary">
                    {genre.trim()}
                    {index < recommendation.show.genres.split(',').length - 1 && ', '}
                  </Typography>
                ))}
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                <strong>Año:</strong> {recommendation?.show.releaseYear}
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                <strong>Sinopsis:</strong> {recommendation?.show.overview}
              </Typography>
              <Box sx={{ mt: 3 }}>
                <Typography variant="body2" color="text.secondary" paragraph>
                  <strong>Recomendaciones</strong>
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <ThumbUpAltIcon color="success" sx={{ mr: 1 }} />
                  <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
                    Positivas: {recommendation?.reviews?.positive?.count}
                  </Typography>
                  <Box sx={{ ml: 1 }}>
                    {recommendation?.reviews?.positive?.voters.map(renderVoterChip)}
                  </Box>
                </Box>
                <Divider variant="middle" sx={{ mb: 2 }} />
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <ThumbDownAltIcon color="error" sx={{ mr: 1 }} />
                  <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
                    Negativas: {recommendation?.reviews?.negative?.count}
                  </Typography>
                  <Box sx={{ ml: 1 }}>
                    {recommendation?.reviews?.negative?.voters.map(renderVoterChip)}
                  </Box>
                </Box>
              </Box>
            </CardContent>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cerrar
        </Button>
        <Button
          variant="contained"
          color="error"
          startIcon={<YouTubeIcon />}
          component="a"
          href={generateTrailerLink(recommendation?.show.title, recommendation?.show.releaseYear)}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ textTransform: 'none' }}
        >
          Buscar trailer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecommendationDetail;
